module.exports = "<md-dialog> <div layout-padding> <h2 class=md-title> <span translate>PREDICTION_DATE</span> </h2> <md-datepicker ng-model=$ctrl.predictionDate required></md-datepicker> </div> <md-dialog-actions layout=row> <md-button ng-click=$ctrl.cancel()> <span translate>CANCEL</span> </md-button> <md-button ng-click=$ctrl.apply()> <span translate>OK</span> </md-button> </md-dialog-actions> </md-dialog>";


/*****************
 ** WEBPACK FOOTER
 ** ./app/station/forecast-model/prediction-date-dialog.html
 ** module id = 507
 ** module chunks = 0
 **/